import * as React from "react";

function SvgIcons8LoadBalancer(props, ref) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...{ ...props, ref }}>
      <path d="M20 4v6.568l-4 3.334V4.037H4v24h12v-9.863l4 3.334V28h8V17h-8V18.902l-3.438-2.863L20 13.174V15h8V4h-8zm2 2h4v7h-4V6zM6 6.037h8v20H6v-20zM8 8v2h4V8H8zm16 2a1 1 0 100 2 1 1 0 000-2zM8 12v2h4v-2H8zm14 7h4v7h-4v-7zm-12 3a1 1 0 100 2 1 1 0 000-2zm14 1a1 1 0 100 2 1 1 0 000-2z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8LoadBalancer);
